import { lazy } from "react";
import AuthLayout from "@pages/auth/ui/AuthLayout";
import PublicRoute from "@app/providers/auth/PublicRoute";

const Login = lazy(() => import("@pages/auth/login/Login"));
const Register = lazy(() => import("@pages/auth/registration/Register"));
const ResetPassword = lazy(
  () => import("@pages/auth/ResetPassword/ResetPassword"),
);
const MailPage = lazy(
  () => import("@pages/auth/ResetPasswordMailPage/MailPage"),
);

export const authRoutes = {
  path: "/auth",
  element: (
    <PublicRoute>
      <AuthLayout />
    </PublicRoute>
  ),
  children: [
    { path: "login", element: <Login /> },
    { path: "register/:referral_token?", element: <Register /> },
    { path: "reset-password", element: <ResetPassword /> },
    { path: "reset-password-email", element: <MailPage /> },
  ],
};
